import React, { Fragment } from 'react';
import { FacetList } from 'Components/widgets/criteria/criteria-facets/search-facets/FacetList';
import { t } from 'Src/i18n';
import { getFacetLocalizedLabel } from './SearchFacets.utils';
type Props = {
  activeCustomFacets: any;
  activeFacets: any;
  facetsFromSearch: Array<SearchFacetCategory>;
  onChange: (name: string, checked: boolean, value: string | boolean) => void;
  templateConfig: FacetTemplateConfig;
};
export const FacetLists = ({
  activeCustomFacets,
  activeFacets,
  facetsFromSearch,
  onChange,
  templateConfig,
}: Props) => {
  const { capitalizeLabels, facetLists: facetListsConfig = [] } = templateConfig;

  const localizeFacetLabel = (facet: SearchFacetList, facetLabels: string = '') => {
    if (!facetLabels) {
      return facet;
    }

    const localizedLabel = getFacetLocalizedLabel({
      facetValue: facet.value,
      facetLabels,
    });

    if (!localizedLabel) {
      return facet;
    }

    return { ...facet, label: localizedLabel };
  };

  return (
    <Fragment>
      {facetListsConfig.map(({ deep, id: subFacetId, facetLabels, titleLabel = '' }) => {
        const facetFromSearch = facetsFromSearch.find(({ id }) => id === subFacetId);

        if (!facetFromSearch || !facetFromSearch.list) {
          return;
        }

        if (!deep) {
          return (
            <FacetList
              activeCustomFacets={activeCustomFacets[subFacetId]}
              activeFacets={activeFacets[subFacetId]}
              capitalizeLabels={capitalizeLabels}
              className={`FacetList-${subFacetId}`}
              facets={facetFromSearch.list.map((facet) => localizeFacetLabel(facet, facetLabels))}
              key={subFacetId}
              name={subFacetId}
              onChange={onChange}
              title={t(titleLabel)}
            />
          );
        }

        return facetFromSearch.list.map(({ label, list = [], value }) => (
          <FacetList
            activeCustomFacets={activeCustomFacets[subFacetId]}
            activeFacets={activeFacets[subFacetId]}
            capitalizeLabels={capitalizeLabels}
            className={`FacetList-${subFacetId}`}
            facets={list.map((facet) => localizeFacetLabel(facet, facetLabels)) || []}
            key={value}
            name={subFacetId}
            onChange={onChange}
            title={label || t(titleLabel)}
          />
        ));
      })}
    </Fragment>
  );
};
